import type { ReportGroup } from '../types';
import { claims } from './claims';
import { orders } from './orders';
import { shippingLines } from './shippingLines';
import { sustainability } from './sustainability';

export const shippingProtection = {
  key: 'shippingProtection',
  label: 'Shipping Protection',
  isEnabled: ({ isCheckoutPlusEnabled }) => isCheckoutPlusEnabled,
  filters: {},
  reports: [orders, claims, shippingLines, sustainability],
} as const satisfies ReportGroup;
